import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    catalogCreate
} from '../redux/actions'

class AdminAddCatalog extends Component {

    constructor(){
        super()
        this.state = {
            toggleMenu: false,
            catalog: "",
            title: ""
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _onHandleChange(event) {
        if(event.target.files) {
            this.setState({
                [event.target.name]: event.target.files[0]
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }

    _onSubmit() {
        const data = {
            catalog_id: (new Date()).getTime(),
            title: this.state.title,
            file: this.state.catalog,
            created_by: this.props.user
        }
        if(this.state.title && this.state.catalog) {
            this.props.catalogCreate(data)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() { 
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-addcatalog">
                    <Nav active="catalog"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>แคตตาล็อก : เพิ่มรายการ</h2>
                            </div>
                            <div className="info">
                                <div className="adjust">
                                    <form className="text">
                                        <div className="model">
                                            <p>ชื่อ</p>
                                            <input type="text" name="title" onChange={(event) => this._onHandleChange(event)}></input>
                                        </div>
                                    </form>
                                    <form className="catalog">
                                        <div className="catalog-title">
                                            <p>แคตตาล็อก</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.catalog.name}</p>
                                        </div>
                                        <div className="file-input">
                                            <input id="catalog" type="file" name="catalog" accept="image/jpeg,image/gif,image/png,application/pdf" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="catalog">เลือกไฟล์</label>
                                        </div>
                                    </form>
                                    <div className="btn-submit">
                                        {
                                            (this.props.loading) ?
                                            <p style={{textAlign: 'center'}}>Loading...</p>
                                            : <BtnSave click={() => this._onSubmit()}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, catalog }) => {
    return { 
        user: auth.user,
        loading: catalog.loading
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, catalogCreate
})(AdminAddCatalog)